import * as React from 'react';
import {cn} from '../../lib/cn';
import {CopyIcon, type CopyIconProps} from '../../copy-icon';
import {Input, type InputProps} from '../input';

type CopyInputProps = Omit<InputProps, 'readOnly' | 'onReset' | 'trailingAdornment'> & {
  value?: string;
  copyTooltip?: string;
  copySize?: CopyIconProps['size'];
  copyVariant?: CopyIconProps['variant'];
  onCopy?: CopyIconProps['onClick'];
};

const CopyInput = React.forwardRef<HTMLInputElement, CopyInputProps>(
  ({value = '', copyTooltip, copySize, copyVariant = 'ghost', onCopy, ...props}, ref) => {
    return (
      <Input
        {...props}
        ref={ref}
        value={value}
        readOnly
        trailingAdornment={
          <span className="pointer-events-auto">
            <CopyIcon
              textToCopy={value}
              tooltipText={copyTooltip}
              size={copySize}
              variant={copyVariant}
              onClick={onCopy}
            />
          </span>
        }
        inputClassName={cn('pr-12', props.inputClassName)}
      />
    );
  },
);

CopyInput.displayName = 'CopyInput';

export {CopyInput};
export type {CopyInputProps};
